import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";
import PropTypes from "prop-types";

export default function Dropdown({
  label,
  items = [],
  className,
  contentProps,
  onSelect,
  disabled = false,
}) {
  const handleSelect = (item) => {
    if (disabled) return; 

    if (onSelect) {
      onSelect(item);
      return;
    }

    if (item.onSelect) {
      item.onSelect(item);
    }
  };

  const {
    className: contentClassName,
    sideOffset,
    ...restContentProps
  } = contentProps ?? {};

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="cursor-pointer disabled:cursor-not-allowed disabled:opacity-50" disabled={disabled}>
        {label}
      </DropdownMenuTrigger>

      <DropdownMenuContent
        sideOffset={sideOffset ?? 4}
        className={cn(
          "bg-white rounded-[16px] px-2 text-[var(--color-neutral-400)] shadow-light-sm",
          className,
          contentClassName,
        )}
        {...restContentProps}
      >
        {items.map((item, idx) => {
          if (item.separator) {
            return <DropdownMenuSeparator key={idx} />;
          }

          if (item.type === "label") {
            return (
              <DropdownMenuLabel key={idx}>
                {item.label}
              </DropdownMenuLabel>
            );
          }

          return (
            <DropdownMenuItem
              key={idx}
              onClick={() => handleSelect(item)}
              className={`cursor-pointer ${disabled ? "opacity-50 pointer-events-none" : ""}`}
              disabled={item.disabled || disabled}
            >
              {item.icon && <item.icon className="mr-2 h-4 w-4" />}
              {item.label}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

Dropdown.propTypes = {
  label: PropTypes.node.isRequired,
  className: PropTypes.string,
  contentProps: PropTypes.object,
  onSelect: PropTypes.func,
  disabled: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node,
      value: PropTypes.any,
      icon: PropTypes.elementType,
      disabled: PropTypes.bool,
      onSelect: PropTypes.func,
      separator: PropTypes.bool,
      type: PropTypes.oneOf(["label"]),
    })
  ),
};